import { Heading, SkeletonBox } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

export interface TradeDetailHeadingProps {
  /**
   * Trade Title.
   */
  title: string
  /**
   * Display loading state.
   */
  loading: boolean
  /**
   * Job ID.
   */
  jobId: string
  /**
   * Custom Style?
   */
  className?: string
}

export const TradeDetailHeading: React.FC<TradeDetailHeadingProps> = ({
  title,
  loading = false,
  jobId: id,
  className,
}) => {
  const { t } = useTranslation('payments')

  return (
    <Heading className={className} variant="page/sm">
      <Heading.Eyebrow>
        <SkeletonBox className="my-1 h-4 w-36" loading={loading}>
          {title}
        </SkeletonBox>
      </Heading.Eyebrow>
      <Heading.Intro>
        <SkeletonBox className="my-1 h-4 w-58" loading={loading}>
          {t('tradeDetail.jobId', { id })}
        </SkeletonBox>
      </Heading.Intro>
    </Heading>
  )
}
